// COMPONENT
import HeaderComponent from "../../components/Header"
import MenuComponent from "../../components/SideMenu"
import BreadcrumbComponent from "../../components/Breadcrumb"

// LIBRARY
import Swal from "sweetalert2"
import { toast } from "react-toastify"
import Cookies from "universal-cookie"
import ReactLoading from "react-loading"
import React, { Component } from "react"
import Pagination from "react-js-pagination"
import { Slide } from "react-slideshow-image"
import DateRangePicker from "react-bootstrap-daterangepicker"

// CSS
import "../../components/css/style.css"
import "../../components/css/bootstrap.css"
import "react-slideshow-image/dist/styles.css"
import "bootstrap-daterangepicker/daterangepicker.css"

const cookies = new Cookies()
toast.configure()

let month_array = [
  "",
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
]
export default class InAndOutListScreen extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modal_detail: false,
      modal_detail_many: false,
      modal_filter: false,
      modal_photo: false,
      modal_photos: false,
      modal_profile: false,
      profile: null,
      filter: false,

      token: cookies.get("token") ? "token " + cookies.get("token") : "",

      filter_startdate:
        new Date(
          new Date().setFullYear(new Date().getFullYear() - 1)
        ).getFullYear() +
        "-" +
        ("00" + (new Date().getMonth() + 1)).slice(-2) +
        "-" +
        ("00" + new Date().getDate()).slice(-2),

      filter_enddate:
        new Date().getFullYear() +
        "-" +
        ("00" + (new Date().getMonth() + 1)).slice(-2) +
        "-" +
        ("00" + new Date().getDate()).slice(-2),

      filter_visitor: "all",
      filter_status: "all",
      filter_agency: "all",
      filter_project: "all",

      data_search: "",

      photo_big: "",
      photo_array: [],

      photo_bigs: "",
      photo_arrays: [],

      data: null,
      detail: null,
      detail_many: null,
      project:
        cookies.get("user_profile").agency_list &&
        cookies.get("user_profile").agency_list
          ? cookies.get("user_profile").agency_list
          : null,
      agency: null,

      filter_visitor_type: [],
      slider: [],

      index: 0,
      page: 1,
    }
  }
  componentDidMount() {
    this.get_visitor_type()
    this.get_In_Out()
    var user = cookies.get("user_profile")
    if (user.role_data.role_name === "system_admin") {
      this.get_Project()
    } else {
      this.setState(prev => {
  const profile = cookies.get("user_profile");

  // ถ้ามี project_id นี้แล้ว → ไม่เพิ่ม
  if (prev.project.some(p => p.project_id === profile.project_id)) {
    return null; // ไม่เปลี่ยน state
  }

  return {
    project: [
      ...prev.project,
      {
        agency_id: profile.agency_id,
        agency_name: profile.agency_name,
        project_id: profile.project_id,
        project_name: profile.project_name,
      },
    ],
  };
});
    }
  }

  get_visitor_type() {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
    }
    fetch(global.api + "v1/in-out-area/on-web/type-card/all", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ filter_visitor_type: result.data.data })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ project: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  get_In_Out() {
    this.setState({ loading: true })

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
    }
    fetch(
      global.api + "v1/in-out-area/on-web/page/" + this.state.page,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ data: result.data })
          this.setState({ loading: false })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ data: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  get_Project() {
    this.setState({ loading: true })
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
    }
    fetch(global.api + "v1/project/all", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ project: result.data.data })
          this.setState({ loading: false })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ project: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  get_Agency() {
    this.setState({ loading: true })
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
      body: JSON.stringify({
        project_id: this.state.filter_project,
      }),
    }
    fetch(global.api + "v1/project/agency", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ agency: result.data.data })
          this.setState({ loading: false })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ agency: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  get_Detail(date, time, id, index, type_card_id) {
    this.setState({ loading: true, index: index })

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
    }
    fetch(
      global.api +
        "v1/in-out-area/company/" +
        date +
        "/" +
        time +
        "/" +
        id +
        "/" +
        type_card_id,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          let slider = []

          if (result.data.data[0].company_name) {
            for (let sl of result.data.data[0].document_img_in_list) {
              slider.push({
                url: sl,
              })
            }
            this.setState({ detail: result.data.data[0], slider: slider })
            this.setState({ modal_detail: true })
          } else {
            let array = []
            for (let sl of result.data.data) {
              array = [...array, ...sl.document_img_in_list]
            }
            for (let sl of array) {
              slider.push({
                url: sl,
              })
            }

            this.setState({ detail_many: result.data.data, slider: slider })
            this.setState({ modal_detail_many: true })
          }
          this.setState({ loading: false })
        } else {
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        console.log(e)
        this.setState({ loading: false })
      })
  }

  filter() {
    this.setState({ loading: true, filter: true })

    let status =
      this.state.filter_status === "1"
        ? 1
        : this.state.filter_status === "2"
        ? 2
        : "all"

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
      body: JSON.stringify({
        start_date:
          this.state.filter_startdate.split("-")[0] +
          "-" +
          this.state.filter_startdate.split("-")[1] +
          "-" +
          this.state.filter_startdate.split("-")[2],
        end_date:
          this.state.filter_enddate.split("-")[0] +
          "-" +
          this.state.filter_enddate.split("-")[1] +
          "-" +
          this.state.filter_enddate.split("-")[2],
        visitor_type_card_id: this.state.filter_visitor,
        agency_id: this.state.filter_agency,
        project_id: this.state.filter_project,
        status: status,
      }),
    }
    fetch(
      global.api + "v1/in-out-area/on-web/filter/page/" + this.state.page,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ data: result.data })
          this.setState({ loading: false })
        } else {
          switch (result.data.message) {
            case "This Page is not available":
              this.alert("info", "แจ้งเตือน", "ไม่พบหน้า")
              this.setState({ loading: false })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  search() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
      body: JSON.stringify({
        data_search: this.state.data_search,
      }),
    }
    fetch(
      global.api + "v1/in-out-area/on-web/search/page/" + this.state.page,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          if (result.data.data.length === 0) {
            this.alert("info", "แจ้งเตือน", "ค้นหาไม่พบ")
            this.setState({ data_search: "" })
          } else {
            this.setState({ data: result.data })
          }

          this.setState({ loading: false })
        } else {
          switch (result.data.message) {
            case "This Page is not available":
              this.alert("info", "แจ้งเตือน", "ไม่พบหน้า")
              break
            default:
              this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  alert(icon, title, detail) {
    Swal.fire({
      icon: icon,
      title: title,
      text: detail,
      confirmButtonText: "ตกลง",
    })
  }

  handlePageChange(pageNumber) {
    this.setState({ page: pageNumber })

    if (this.state.search) {
      setTimeout(() => {
        this.search()
      }, 10)
    } else if (this.state.filter) {
      setTimeout(() => {
        this.filter()
      }, 10)
    } else {
      setTimeout(() => {
        this.get_In_Out()
      }, 10)
    }
  }

  clear_form() {
    this.setState({
      loading: false,
      modal_detail: false,
    })
  }

  get_Profile(id) {
    this.setState({ modal_profile: true })
  }

  render() {
    return (
      <div className="full bg-contain">
        {this.state.loading && (
          <div className="loading">
            <ReactLoading
              type={"spinningBubbles"}
              color="#fff"
              height={48}
              width={48}
            />
          </div>
        )}
        <div className="menu-container ">
          <MenuComponent />

          <div className="w-100 ">
            <BreadcrumbComponent
              page1="เข้า-ออกพื้นที่"
              page2="รายการเข้า-ออก"
            />
            <HeaderComponent header="เข้า-ออกพื้นที่" report="true" />
            {/* เมนู ฟิลเตอร์  */}
            <div className="bg-gray px-3 pt-3 w-100">
              <div className="row d-flex mx-0 justify-content-between">
                <div className="d-flex row mx-0">
                  {/* ค้นหา */}
                  <div className="mx-2 mb-3">
                    <input
                      className="form-control bg-white"
                      type="search"
                      placeholder="เลขที่บัตร, ชื่อบริษัท, ชื่อ"
                      value={this.state.data_search}
                      onChange={(e) => {
                        this.setState({ data_search: e.target.value })
                        if (e.target.value === "") {
                          this.setState({
                            page: 1,
                            search: false,
                            filter: false,
                            data_search: "",
                            filter_status: "all",
                            filter_agency: "all",
                            filter_project: "all",
                            filter_visitor: "all",
                            filter_startdate:
                              new Date(
                                new Date().setFullYear(
                                  new Date().getFullYear() - 1
                                )
                              ).getFullYear() +
                              "-" +
                              ("00" + (new Date().getMonth() + 1)).slice(-2) +
                              "-" +
                              ("00" + new Date().getDate()).slice(-2),
                            filter_enddate:
                              new Date().getFullYear() +
                              "-" +
                              ("00" + (new Date().getMonth() + 1)).slice(-2) +
                              "-" +
                              ("00" + new Date().getDate()).slice(-2),
                          })
                          setTimeout(() => {
                            this.get_In_Out()
                          }, 10)
                        }
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          this.setState({
                            page: 1,
                            search: true,
                            filter_status: "all",
                            filter_project: "all",
                            filter_agency: "all",
                            filter_visitor: "all",
                          })
                          setTimeout(() => {
                            this.search()
                          }, 10)
                        }
                      }}
                    ></input>
                  </div>
                </div>
                <div className="d-flex row mx-0">
                  {/* ตัวกรองโครงการ */}
                  <div className="mx-2 mb-3">
                    <button
                      className="btn btn-outline-primary bg-white "
                      onClick={() => {
                        this.setState({ modal_filter: true })
                      }}
                    >
                      <span className="icon mr-2">{"\uf1de"}</span>
                      ตัวกรองโครงการ
                    </button>
                    <div
                      class={this.state.modal_filter ? "bg-modal" : ""}
                      onClick={() => {
                        this.setState({ modal_filter: false })
                      }}
                    ></div>

                    {/* modal */}
                    <div
                      class={
                        this.state.modal_filter
                          ? "card border-0 modal-filter p-3 mt-3"
                          : "d-none"
                      }
                    >
                      {/* โครงการ */}
                      <div class="row my-2">
                        <div class="col-4">โครงการ:</div>
                        <div class="col-8">
                          <select
                            className="form-control"
                            value={this.state.filter_project}
                            onChange={(e) => {
                              this.setState({
                                filter_project: e.target.value,
                                filter_agency: "all",
                              })
                              setTimeout(() => {
                                this.get_Agency()
                              }, 10)
                            }}
                          >
                            <option value="all" selected disabled>
                              -- เลือกโครงการ --
                            </option>
                            {this.state.project &&
                              this.state.project.map((item, index) => (
                                <option value={item.project_id} key={index}>
                                  {item.project_name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      {/* หน่วยงาน */}
                      <div class="row my-2">
                        <div class="col-4">หน่วยงาน:</div>
                        <div class="col-8">
                          <select
                            className="form-control"
                            value={this.state.filter_agency}
                            onChange={(e) => {
                              this.setState({ filter_agency: e.target.value })
                            }}
                          >
                            <option value="all" selected disabled>
                              -- เลือกหน่วยงาน --
                            </option>
                            {this.state.agency &&
                              this.state.agency.map((item, index) => (
                                <option value={item.agency_id} key={index}>
                                  {item.agency_name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <hr class="my-1" />
                      {/* ปุ่ม */}
                      <div class="row my-2">
                        <div class="col-4"></div>
                        <div class="col-8 d-flex">
                          <button
                            className="btn btn-secondary mr-2 w-50"
                            onClick={() => {
                              this.setState({
                                filter_date: "",
                                filter_agency: "all",
                                filter_project: "all",
                                filter_status: "all",
                                filter_visitor: "all",
                                page: 1,
                                search: false,
                                filter: false,
                                data_search: "",
                                filter_startdate:
                                  new Date(
                                    new Date().setFullYear(
                                      new Date().getFullYear() - 1
                                    )
                                  ).getFullYear() +
                                  "-" +
                                  ("00" + (new Date().getMonth() + 1)).slice(
                                    -2
                                  ) +
                                  "-" +
                                  ("00" + new Date().getDate()).slice(-2),
                                filter_enddate:
                                  new Date().getFullYear() +
                                  "-" +
                                  ("00" + (new Date().getMonth() + 1)).slice(
                                    -2
                                  ) +
                                  "-" +
                                  ("00" + new Date().getDate()).slice(-2),
                              })

                              setTimeout(() => {
                                this.get_In_Out()
                              }, 10)

                              this.setState({
                                modal_filter: false,
                              })
                            }}
                          >
                            รีเซ็ท
                          </button>
                          <button
                            className="btn btn-primary ml-2 w-50"
                            onClick={() => {
                              this.setState({
                                filter_status: "",
                                filter_visitor: "",
                                page: 1,
                                data_search: "",
                                search: false,
                              })

                              setTimeout(() => {
                                this.filter()
                              }, 10)

                              this.setState({
                                modal_filter: false,
                              })
                            }}
                          >
                            <span className="icon mr-2">{"\uf1de"}</span>
                            ยืนยัน
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* สถานะ */}
                  <div className="mx-2 mb-3">
                    <select
                      className="form-control"
                      value={this.state.filter_status}
                      onChange={(e) => {
                        this.setState({
                          filter_status: e.target.value,
                          page: 1,
                          data_search: "",
                        })
                        setTimeout(() => {
                          this.filter()
                        }, 10)
                      }}
                    >
                      <option value="all" selected>
                        แสดงทุกสถานะ
                      </option>
                      <option value="1">อยู่ในพื้นที่</option>
                      <option value="2">ออกนอกพื้นที่</option>
                    </select>
                  </div>

                  {/* ประเภทของบัตร */}
                  <div className="mx-2 mb-3 w-180px">
                    <select
                      className="form-control"
                      value={this.state.filter_visitor}
                      onChange={(e) => {
                        this.setState({
                          filter_visitor: e.target.value,
                          page: 1,
                          data_search: "",
                        })
                        setTimeout(() => {
                          this.filter()
                        }, 10)
                      }}
                    >
                      <option value="all" selected>
                        แสดงบัตรทุกประเภท
                      </option>
                      {this.state.filter_visitor_type.map((item, index) => (
                        <option value={item.type_card_id} key={index}>
                          {item.type_card_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* วันที่ */}
                  <div className="mx-2 mb-3 w-250px">
                    <DateRangePicker
                      initialSettings={{
                        startDate: new Date(),
                        endDate: new Date(),
                        locale: {
                          format: "DD/MM/YYYY",
                        },
                      }}
                      onApply={(e) => {
                        let value = e.target.value
                        let start = value.split(" - ")[0]
                        let end = value.split(" - ")[1]
                        let startdate =
                          start.split("/")[2] +
                          "-" +
                          start.split("/")[1] +
                          "-" +
                          start.split("/")[0]
                        let enddate =
                          end.split("/")[2] +
                          "-" +
                          end.split("/")[1] +
                          "-" +
                          end.split("/")[0]

                        this.setState({
                          page: 1,
                          filter_startdate: startdate,
                          filter_enddate: enddate,
                          data_search: "",
                        })
                        setTimeout(() => {
                          this.filter()
                        }, 10)
                      }}
                    >
                      <input type="text" className="form-control " />
                    </DateRangePicker>
                  </div>
                </div>
              </div>
            </div>

            {/* ตาราง */}
            {this.state.data &&
            this.state.data.data &&
            this.state.data.data.length === 0 ? (
              <div className="w-100 p-3">
                <div className="table-responsive">
                  <table className="table design-table">
                    <thead>
                      <tr>
                        <th className="text-left">วันเวลานำเข้า</th>
                        <th className="text-left">บัตรเข้า-ออก</th>
                        <th className="text-left">บริษัท</th>
                        <th className="text-left">สถานที่ติดต่อ</th>
                        <th className="text-left">จุดประสงค์</th>
                        <th className="text-center w-150px">สถานะ</th>
                        <th className="text-center">รายละเอียด</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={7} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="w-100 p-3">
                <div className="table-responsive">
                  <table className="table design-table">
                    <thead>
                      <tr>
                        <th className="text-left">วันเวลานำเข้า</th>
                        <th className="text-left">บัตรเข้า-ออก</th>
                        <th className="text-left">บริษัท</th>
                        <th className="text-left">สถานที่ติดต่อ</th>
                        <th className="text-left w-150px">จุดประสงค์</th>
                        <th className="text-center w-150px">สถานะ</th>
                        <th className="text-center">รายละเอียด</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.data &&
                        this.state.data.data &&
                        this.state.data.data.map((item, index) => (
                          <tr>
                            <td>
                              {item.rec_in_date
                                ? item.rec_in_date.slice(8, 10) +
                                  " " +
                                  month_array[
                                    Number(item.rec_in_date.slice(5, 7))
                                  ] +
                                  " " +
                                  (Number(item.rec_in_date.slice(0, 4)) + 543)
                                    .toString()
                                    .slice(-2) +
                                  " , " +
                                  item.rec_in_time +
                                  " น."
                                : " - "}
                            </td>
                            <td>
                              {item.type_card_name ? item.type_card_name : "-"}
                            </td>
                            <td>
                              {item.company_name ? item.company_name : "-"}
                            </td>

                            <td>
                              {item.contact_location
                                ? item.contact_location
                                : "-"}
                            </td>
                            <td>{item.objective ? item.objective : "-"}</td>

                            <td className="text-center">
                              <span
                                className={
                                  item.status === 1
                                    ? "status bg-orenge"
                                    : "status bg-blue-light"
                                }
                              >
                                {item.status === 1
                                  ? "อยู่ในพื้นที่"
                                  : "ออกนอกพื้นที่"}
                              </span>
                            </td>

                            <td className="text-center">
                              <button
                                className="btn btn-link"
                                onClick={() => {
                                  this.get_Detail(
                                    item.rec_in_date,
                                    item.rec_in_time,
                                    item.company_id,
                                    index,
                                    item.type_card_id
                                  )
                                }}
                              >
                                <span className="icon mr-2">{"\uf06e"}</span>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* pagination */}
            {this.state.data && this.state.data.data.length !== 0 && (
              <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                <div>
                  <span>
                    แสดง {this.state.data.end_index} จาก {this.state.data.count}{" "}
                    รายการ
                  </span>
                </div>
                <div className="d-flex">
                  <button
                    className="btn-circle-white mx-1"
                    onClick={() => {
                      this.handlePageChange(1)
                    }}
                  >
                    <span className="icon">{"\uf100"}</span>
                  </button>
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={10}
                    totalItemsCount={this.state.data.count}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                    prevPageText={<span className="icon">{"\uf104"}</span>}
                    nextPageText={<span className="icon">{"\uf105"}</span>}
                    hideFirstLastPages={true}
                  />
                  <button
                    className="btn-circle-white mx-1"
                    onClick={() => {
                      this.handlePageChange(this.state.data.page_number)
                    }}
                  >
                    <span className="icon">{"\uf101"}</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* modal */}
        <div className={this.state.modal_detail ? "show-modal" : "hide-modal"}>
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.setState({ modal_detail: false })
            }}
          ></div>
          <div
            className={
              this.state.modal_detail ? "box-modal p-4" : "hide-box-modal p-4"
            }
          >
            {/* ปุ่มปิด */}
            <div className="w-100">
              <button
                className="btn btn-link d-block d-md-none ml-auto"
                onClick={() => {
                  this.setState({ modal_detail: false })
                }}
              >
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>
            <div className="slide-container mb-3">
              {this.state.slider.length === 0 ? (
                <div className="no-image">
                  <span className="icon-no-image"> {"\uf302"}</span>
                </div>
              ) : (
                <>
                  <Slide
                    arrows={this.state.slider.length === 1 ? false : true}
                    indicators={true}
                    pauseOnHover={true}
                    infinite={false}
                  >
                    {this.state.slider.map((slideImage, index) => (
                      <div className="each-slide" key={index}>
                        <div
                          style={{
                            backgroundImage: `url(${slideImage.url})`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            height: 254,
                            borderRadius: 16,
                          }}
                          onClick={() => {
                            for (let i = 0; i < this.state.slider.length; i++) {
                              let img_url = this.state.slider[i].url
                              this.state.photo_arrays.push(img_url)
                            }

                            setTimeout(() => {
                              this.setState({
                                modal_photos: true,
                                photo_bigs: slideImage.url,
                              })
                            }, 1)
                          }}
                        ></div>
                      </div>
                    ))}
                  </Slide>
                </>
              )}
            </div>
            {/* วันที่นำเข้า - เวลานำเข้า */}
            <div className="d-flex justify-content-around align-items-center">
              <div className="w-50 text-center">
                <span className="icon text-secondary mr-2 text-24">
                  {"\uf133"}
                </span>
                <br />
                {this.state.detail && (
                  <b>
                    {this.state.detail.rec_in_date
                      ? this.state.detail.rec_in_date.slice(8, 10) +
                        " " +
                        month_array[
                          Number(this.state.detail.rec_in_date.slice(5, 7))
                        ] +
                        " " +
                        Number(this.state.detail.rec_in_date.slice(0, 4))
                          .toString()
                          .slice(-2)
                      : " - "}
                  </b>
                )}
                <br />
                <span className="text-secondary">วันที่นำเข้า</span>
              </div>
              <div className="line-secondary"></div>
              <div className="w-50 text-center">
                <span className="icon text-secondary mr-2 text-24">
                  {"\uf017"}
                </span>
                <br />
                <b>
                  {this.state.detail && this.state.detail.rec_in_time
                    ? this.state.detail.rec_in_time
                    : "-"}{" "}
                  น.
                </b>
                <br />
                <span className="text-secondary">เวลานำเข้า</span>
              </div>
            </div>
            <hr />

            {/* ข้อมูลคนเข้า */}
            {this.state.detail &&
              this.state.detail.client_data_list &&
              this.state.detail.client_data_list.map((item, index) => (
                <>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    key={index}
                  >
                    <div className="d-flex align-items-center">
                      {item.picture ? (
                        <div className="user-image mr-3">
                          <img
                            className="user-image"
                            alt="tag"
                            src={item.picture}
                          ></img>
                        </div>
                      ) : (
                        <div className="mr-3 user-no-image text-center">
                          <span className="icon text-secondary">
                            {"\uf406"}
                          </span>
                        </div>
                      )}

                      <div>
                        <b>{item.full_name ? item.full_name : "-"}</b>
                        <br />
                        <span className="text-secondary">
                          {"เลขที่บัตร: " + item.visitor_card_number
                            ? item.visitor_card_number
                            : "-"}
                        </span>
                      </div>
                    </div>
                    <div
                      className="d-flex pointer"
                      onClick={() => {
                        this.setState({
                          modal_profile: true,
                          profile: item,
                        })
                      }}
                    >
                      <span
                        className={
                          item.status === 1
                            ? "status bg-orenge"
                            : "status bg-blue-light"
                        }
                      >
                        {item.status === 1 ? "อยู่ในพื้นที่" : "ออกนอกพื้นที่"}
                      </span>
                      <span className="icon text-secondary ml-3 text-20">
                        {"\uf054"}
                      </span>
                    </div>
                  </div>
                  <hr />
                </>
              ))}
            {/* แลกบัตรเข้า-ออก */}
            <div className="d-flex justify-content-between my-2">
              <span className="text-secondary">แลกบัตรเข้า-ออก:</span>
              <span className="w-75 text-right">
                {this.state.detail && this.state.detail.visitor_type_card_name
                  ? this.state.detail.visitor_type_card_name
                  : "-"}
              </span>
            </div>
            {/* ชื่อบริษัท */}
            <div className="d-flex justify-content-between my-2">
              <span className="text-secondary">ชื่อบริษัท:</span>
              <span className="w-75 text-right">
                {this.state.detail && this.state.detail.company_name
                  ? this.state.detail.company_name
                  : "-"}
              </span>
            </div>
            <hr />
            {/* ยี่ห้อรถ */}
            <div className="d-flex justify-content-between mb-2">
              <span className="text-secondary">ยี่ห้อรถ:</span>
              <span className="w-75 text-right">
                {this.state.detail && this.state.detail.car_brand
                  ? this.state.detail.car_brand
                  : "-"}
              </span>
            </div>
            {/* เลขทะเบียน */}
            <div className="d-flex justify-content-between mb-2">
              <span className="text-secondary">เลขทะเบียน:</span>
              <span className="w-75 text-right">
                {this.state.detail && this.state.detail.car_regis_number
                  ? this.state.detail.car_regis_number
                  : "-"}
              </span>
            </div>
            <hr />
            {/* สถานที่ติดต่อ */}
            <div className="d-flex justify-content-between mb-2">
              <span className="text-secondary">สถานที่ติดต่อ:</span>
              <span className="w-75 text-right">
                {this.state.detail && this.state.detail.contact_location
                  ? this.state.detail.contact_location
                  : "-"}
              </span>
            </div>
            {/* จุดประสงค์ */}
            <div className="d-flex justify-content-between mb-2">
              <span className="text-secondary">จุดประสงค์:</span>
              <span className="w-75 text-right">
                {this.state.detail && this.state.detail.objective
                  ? this.state.detail.objective
                  : "-"}
              </span>
            </div>

            {/* เอกสารอื่นๆ */}
            <div className="d-flex justify-content-between mb-2">
              <span className="text-secondary">เอกสารอื่นๆ:</span>
              {this.state.detail &&
              this.state.detail.document_img_out_list.length === 0 ? (
                <>
                  <span className="w-75 text-right">-</span>
                </>
              ) : (
                <div className="d-flex justify-content-end">
                  {this.state.detail &&
                    this.state.detail.document_img_out_list.map(
                      (img, index) => (
                        <div
                          onClick={() => {
                            this.setState({
                              modal_photo: true,
                              photo_big: img,
                              photo_array:
                                this.state.detail.document_img_out_list,
                            })
                          }}
                        >
                          {this.state.detail.document_img_out_list.length >
                          3 ? (
                            <>
                              {index < 3 && (
                                <>
                                  {index === 2 ? (
                                    <div className="position-relative mx-1">
                                      <img
                                        className="out-list-image opacity-img-out-list"
                                        alt="tag"
                                        src={img}
                                      ></img>
                                      <div className="center-img-out-list">
                                        <b>
                                          {"+" +
                                            Number(
                                              this.state.detail
                                                .document_img_out_list.length -
                                                3
                                            )}
                                        </b>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <img
                                        className="out-list-image mx-1"
                                        alt="tag"
                                        src={img}
                                      ></img>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <img
                                className="out-list-image mx-1"
                                alt="tag"
                                src={img}
                              ></img>
                            </>
                          )}
                        </div>
                      )
                    )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* modal profile */}
        <div className={this.state.modal_profile ? "show-modal" : "hide-modal"}>
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.setState({ modal_profile: false })
            }}
          ></div>
          <div
            className={
              this.state.modal_profile ? "box-modal p-4" : "hide-box-modal p-4"
            }
          >
            {/* ปุ่มปิด */}
            <div className="w-100 mb-3">
              <button
                className="btn btn-link align-items-center justify-content-center"
                onClick={() => {
                  this.setState({ modal_profile: false })
                }}
              >
                <span className="icon mr-2 text-24">{"\uf060"}</span>ย้อนกลับ
              </button>
            </div>

            <hr />
            {this.state.profile ? (
              <div>
                {/* รูปถ่าย */}
                <div className="d-flex justify-content-between align-items-center my-2">
                  <span className="text-secondary">รูปถ่าย:</span>

                  {this.state.profile.picture ? (
                    <div className="user-image-big">
                      <img
                        className="user-image-big"
                        alt="tag"
                        src={this.state.profile.picture}
                      ></img>
                    </div>
                  ) : (
                    <div className="mr-3 user-no-image-big text-center ">
                      <span className="icon text-secondary text-20">
                        {"\uf406"}
                      </span>
                    </div>
                  )}
                </div>
                <hr />
                {/* สถานะ */}
                <div className="d-flex justify-content-between align-items-center my-2">
                  <span className="text-secondary">สถานะ:</span>
                  <span
                    className={
                      this.state.profile.status === 1
                        ? "status bg-orenge"
                        : "status bg-blue-light"
                    }
                  >
                    {this.state.profile.status === 1
                      ? "อยู่ในพื้นที่"
                      : "ออกนอกพื้นที่"}
                  </span>
                </div>
                {/* เลขที่บัตร */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">เลขที่บัตร:</span>
                  <span>
                    {this.state.profile.visitor_card_number
                      ? this.state.profile.visitor_card_number
                      : "-"}
                  </span>
                </div>
                {/* หมายเลขบัตรประชาชน */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">หมายเลขบัตรประชาชน:</span>
                  <span>
                    {this.state.profile.id_card
                      ? this.state.profile.id_card
                      : "-"}
                  </span>
                </div>
                {/* ชื่อ-นามสกุล */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">ชื่อ-นามสกุล:</span>
                  <span>
                    {this.state.profile.full_name
                      ? this.state.profile.full_name
                      : "-"}
                  </span>
                </div>
                <hr />

                {/* วันเวลาเข้า */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">วันเวลาเข้า:</span>
                  <span className="w-75 text-right">
                    {this.state.detail &&
                      (this.state.detail.rec_in_date
                        ? this.state.detail.rec_in_date.slice(8, 10) +
                          " " +
                          month_array[
                            Number(this.state.detail.rec_in_date.slice(5, 7))
                          ] +
                          " " +
                          Number(this.state.detail.rec_in_date.slice(0, 4))
                            .toString()
                            .slice(-2)
                        : " - ")}{" "}
                    {this.state.detail && this.state.detail.rec_in_time + " น."}
                  </span>
                </div>

                {/* วันเวลาออก */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">วันเวลาออก:</span>
                  <span className="w-75 text-right">
                    {this.state.profile.datetime_out
                      ? this.state.profile.datetime_out.slice(8, 10) +
                        " " +
                        month_array[
                          Number(this.state.profile.datetime_out.slice(5, 7))
                        ] +
                        " " +
                        (
                          Number(this.state.profile.datetime_out.slice(0, 4)) +
                          543
                        )
                          .toString()
                          .slice(-2)
                      : "-"}{" "}
                    {this.state.profile.datetime_out &&
                      this.state.profile.datetime_out.split(" ")[1] + " น."}
                  </span>
                </div>

                <hr />

                {/* ผู้นำเข้า */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">ผู้นำเข้า:</span>
                  <span>
                    {this.state.profile.rec_data_in_by
                      ? this.state.profile.rec_data_in_by
                      : "-"}
                  </span>
                </div>

                {/* ผู้นำออก */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-secondary">ผู้นำออก:</span>
                  <span>
                    {this.state.profile.rec_data_out_by
                      ? this.state.profile.rec_data_out_by
                      : "-"}
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        {/* modal เอกสารอื่นๆ */}
        <div className={this.state.modal_photo ? "show-modal" : "hide-modal"}>
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.setState({ modal_photo: false, photo_array: [] })
            }}
          ></div>
          <div
            className={
              this.state.modal_photo ? "box-modal p-4" : "hide-box-modal p-4"
            }
          >
            {/* ปุ่มปิด */}
            <div className="d-flex justify-content-between">
              <h3>
                <b>ภาพหลักฐาน</b>
              </h3>
              <button
                className="btn btn-link ml-auto"
                onClick={() => {
                  this.setState({ modal_photo: false, photo_array: [] })
                }}
              >
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>

            <div className="w-100 mt-4">
              {this.state.photo_big ? (
                <img
                  className="w-100 img-responsive"
                  style={{ borderRadius: 10 }}
                  alt="tag"
                  src={this.state.photo_big}
                ></img>
              ) : null}
            </div>

            <div className="d-flex mt-4 row justify-content-center">
              {this.state.photo_array &&
                this.state.photo_array.map((img, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      this.setState({
                        photo_big: img,
                      })
                    }}
                  >
                    <img
                      className="out-list-image m-1"
                      alt="tag"
                      src={img}
                    ></img>
                  </div>
                ))}
            </div>
          </div>
        </div>

        {/* modal photo */}
        <div className={this.state.modal_photos ? "show-modal" : "hide-modal"}>
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.setState({ modal_photos: false, photo_arrays: [] })
            }}
          ></div>
          <div
            className={
              this.state.modal_photos ? "box-modal p-4" : "hide-box-modal p-4"
            }
          >
            {/* ปุ่มปิด */}
            <div className="d-flex justify-content-between">
              <h3>
                <b>ภาพหลักฐาน</b>
              </h3>
              <button
                className="btn btn-link ml-auto"
                onClick={() => {
                  this.setState({ modal_photos: false, photo_arrays: [] })
                }}
              >
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>

            <div className="w-100 mt-4">
              {this.state.photo_bigs ? (
                <img
                  className="w-100 img-responsive"
                  style={{ borderRadius: 10 }}
                  alt="tag"
                  src={this.state.photo_bigs}
                ></img>
              ) : null}
            </div>

            <div className="d-flex mt-4 row justify-content-center">
              {this.state.photo_arrays &&
                this.state.photo_arrays.map((imgs, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      this.setState({
                        photo_bigs: imgs,
                      })
                    }}
                  >
                    <img
                      className="out-list-image m-1"
                      alt="tag"
                      src={imgs}
                    ></img>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
